var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"background",attrs:{"src":"https://images.unsplash.com/photo-1551158423-100d177bfaae?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }